/* eslint-disable prefer-destructuring, new-cap */
import 'pixi-projection';
import * as mathjs from 'mathjs';

export default class RectifiedImage extends PIXI.Container {
  constructor(url, camera_view) {
    super();
    this.url = url;
    this.camera_view = camera_view;
  }

  rectify() {
    return new Promise(async (resolve, reject) => {
      try {
        const image = new Image();
        image.crossOrigin = true;
        image.src = this.url;
        const texture = PIXI.Texture.from(image);

        texture.once('update', resolve);
        texture.once('error', reject);

        this.projection_sprite = new PIXI.projection.Sprite2d(texture);
        this.texture = texture;

        this.applyRMatrix();
        this.addChildAt(this.projection_sprite);
        this.texture.update();
      } catch (error) {
        console.warn({ rectify: error });
        reject(error);
      }
    });
  }

  applyRMatrix() {
    const { projection_sprite, camera_view, texture } = this;

    const RM = camera_view.rectification_matrix.split(',');

    const rectMatrix = [
      [RM[0], RM[1], RM[2]],
      [RM[3], RM[4], RM[5]],
      [RM[6], RM[7], RM[8]]
    ];

    const topLeft = new PIXI.Point(0, 0);
    const topRight = new PIXI.Point(texture.width, 0);
    const bottomRight = new PIXI.Point(texture.width, texture.height);
    const bottomLeft = new PIXI.Point(0, texture.height);

    const pointMatrix = [
      [topLeft.x, topRight.x, bottomRight.x, bottomLeft.x],
      [topLeft.y, topRight.y, bottomRight.y, bottomLeft.y],
      [1, 1, 1, 1]
    ];

    const result = mathjs.multiply(rectMatrix, pointMatrix);

    const topLeftTransform = new PIXI.Point(result[0][0] / result[2][0], result[1][0] / result[2][0]);
    const topRightTransform = new PIXI.Point(result[0][1] / result[2][1], result[1][1] / result[2][1]);
    const bottomRightTransform = new PIXI.Point(result[0][2] / result[2][2], result[1][2] / result[2][2]);
    const bottomLeftTransform = new PIXI.Point(result[0][3] / result[2][3], result[1][3] / result[2][3]);
    const finalPoints = [topLeftTransform, topRightTransform, bottomRightTransform, bottomLeftTransform];

    projection_sprite.proj.mapSprite(projection_sprite, finalPoints);
  }
}
